import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { HubSpotMeetingLinkTypeKey } from '@/modules/user/constants/HubSpotMeetingLinkTypeKey';
import { LocaleType } from '@/modules/user/constants/LocaleType';
import { HubSpotMeetingLinkType } from '@/modules/user/constants/HubSpotMeetingLinkType';

export class HubspotMeetingLink extends BaseEntityModel {
  id?: number;
  userId?: number;
  type?: HubSpotMeetingLinkTypeKey;
  meetingLink?: string;
  frenchMeetingLink?: string;

  constructor(model: Partial<HubspotMeetingLink> = {}) {
    super(model);

    this.id = model.id;
    this.userId = model.userId;
    this.type = model.type;
    this.meetingLink = model.meetingLink;
    this.frenchMeetingLink = model.frenchMeetingLink;
  }

  get linkType(): HubSpotMeetingLinkType | undefined {
    return HubSpotMeetingLinkType.getByKey(this.type as string);
  }

  getLinkByLocale(locale: string = LocaleType.ENGLISH): string | undefined {
    if (locale === LocaleType.FRENCH) {
      return this.frenchMeetingLink ?? this.meetingLink;
    }

    return this.meetingLink;
  }
}
